import InstantReactAbstractDatabase from './InstantReactAbstractDatabase';
export default class InstantReactWebDatabase extends InstantReactAbstractDatabase {
}
//# sourceMappingURL=InstantReactWebDatabase.js.map